/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideAnalysisResult200ResponseData } from './OverrideAnalysisResult200ResponseData';
import {
    OverrideAnalysisResult200ResponseDataFromJSON,
    OverrideAnalysisResult200ResponseDataFromJSONTyped,
    OverrideAnalysisResult200ResponseDataToJSON,
    OverrideAnalysisResult200ResponseDataToJSONTyped,
} from './OverrideAnalysisResult200ResponseData';

/**
 * 
 * @export
 * @interface OverrideAnalysisResult200Response
 */
export interface OverrideAnalysisResult200Response {
    /**
     * 
     */
    data?: OverrideAnalysisResult200ResponseData;
}

/**
 * Check if a given object implements the OverrideAnalysisResult200Response interface.
 */
export function instanceOfOverrideAnalysisResult200Response(value: object): value is OverrideAnalysisResult200Response {
    return true;
}

export function OverrideAnalysisResult200ResponseFromJSON(json: any): OverrideAnalysisResult200Response {
    return OverrideAnalysisResult200ResponseFromJSONTyped(json, false);
}

export function OverrideAnalysisResult200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideAnalysisResult200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : OverrideAnalysisResult200ResponseDataFromJSON(json['data']),
    };
}

export function OverrideAnalysisResult200ResponseToJSON(json: any): OverrideAnalysisResult200Response {
    return OverrideAnalysisResult200ResponseToJSONTyped(json, false);
}

export function OverrideAnalysisResult200ResponseToJSONTyped(value?: OverrideAnalysisResult200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OverrideAnalysisResult200ResponseDataToJSON(value['data']),
    };
}

